import type {ParametersParameters} from "@cm/template-nodes"

function layerIdSuffix(index: number): string {
    return String(index)
}

export function remapLayerParameters(params: ParametersParameters, unitIdPrefix: string, indexMapping: Map<number, number>): ParametersParameters {
    const segmentMapping = new Map<string, string>()
    for (const [oldIdx, newIdx] of indexMapping) {
        const oldSegment = `${unitIdPrefix}-${layerIdSuffix(oldIdx)}`
        const newSegment = `${unitIdPrefix}-${layerIdSuffix(newIdx)}`
        segmentMapping.set(oldSegment, newSegment)
    }

    const layerSegmentRegex = new RegExp(`(^|/)${unitIdPrefix}-(\\d+)(/|$)`)

    const result: ParametersParameters = {}
    for (const [key, value] of Object.entries(params)) {
        const match = key.match(layerSegmentRegex)
        if (match) {
            const matchedSegment = key.slice(match.index! + match[1].length, match.index! + match[0].length - match[3].length)
            const newSegment = segmentMapping.get(matchedSegment)
            if (newSegment) {
                result[key.replace(matchedSegment, newSegment)] = value
            }
        } else {
            result[key] = value
        }
    }
    return result
}

export function buildAddLayerMapping(unitCount: number, insertAtIndex: number): Map<number, number> {
    const mapping = new Map<number, number>()
    for (let i = 0; i < unitCount; i++) {
        mapping.set(i, i < insertAtIndex ? i : i + 1)
    }
    return mapping
}

export function buildRemoveLayerMapping(unitCount: number, layerIndex: number): Map<number, number> {
    const mapping = new Map<number, number>()
    for (let i = 0; i < unitCount; i++) {
        if (i < layerIndex) {
            mapping.set(i, i)
        } else if (i > layerIndex) {
            mapping.set(i, i - 1)
        }
    }
    return mapping
}

export function buildMoveLayerMapping(unitCount: number, sourceIndex: number, targetIndex: number): Map<number, number> {
    const mapping = new Map<number, number>()
    for (let i = 0; i < unitCount; i++) {
        if (i === sourceIndex) {
            mapping.set(i, targetIndex)
        } else if (sourceIndex < targetIndex && i > sourceIndex && i <= targetIndex) {
            mapping.set(i, i - 1)
        } else if (sourceIndex > targetIndex && i >= targetIndex && i < sourceIndex) {
            mapping.set(i, i + 1)
        } else {
            mapping.set(i, i)
        }
    }
    return mapping
}
